import * as React from 'react';
import { Stack, Label } from 'office-ui-fabric-react';
import { DatePicker } from '../DatePicker';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateRange = () => /*#__PURE__*/_jsxs(Stack, {
  horizontal: true,
  tokens: {
    childrenGap: 5
  },
  children: [/*#__PURE__*/_jsx(DatePicker, {}), /*#__PURE__*/_jsx(Label, {
    children: "to"
  }), /*#__PURE__*/_jsx(DatePicker, {})]
});
export const DateRangeField = _ref => {
  let {
    label = 'Date Range'
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 5
    },
    children: [/*#__PURE__*/_jsx(Label, {
      style: {
        width: 120
      },
      children: label
    }), /*#__PURE__*/_jsx(DateRange, {})]
  });
};